export const enum HttpTypeConfig {
  ARRAY_BUFFER = "arraybuffer",
  BINARY_ENCODE = "binary",
  PDF_CONTENT_TYPE = "application/pdf",
  JSON_CONTENT_TYPE = "application/json; charset=utf-8",
}
